import {
  defaultMapCentraProductToStructuredDataProduct,
  type UnformattedStructuredDataProduct,
} from "@made-people/grease-structured-data";
import { TableMapping } from "@made-people/centra-checkout-api";
import { getLocalizedItemSize } from "./utils/get-localized-item-size";
import { getSizeSystemByCountryCode } from "./utils/get-size-system-by-country-code";
import { getTableMappingIdForCountryCode } from "./utils/get-table-mapping-id-for-country-code";

export function mmCentraProductToStructuredDataProduct(
  productData: unknown,
  countryCode: string,
): UnformattedStructuredDataProduct | undefined {
  const base = defaultMapCentraProductToStructuredDataProduct(productData);
  if (!base) {
    return undefined;
  }

  const tableMappingId = getTableMappingIdForCountryCode(countryCode);
  const tableMappings = (
    productData as { tableMappings?: Record<string, TableMapping> }
  )?.tableMappings;
  const tableMapping = tableMappings?.[tableMappingId];
  const sizeSystem = getSizeSystemByCountryCode(countryCode);

  return {
    ...base,
    variants: base.variants.map((variant) => ({
      ...variant,
      size: tableMapping
        ? getLocalizedItemSize(variant.size, tableMapping)
        : variant.size,
      sizeSystem,
    })),
  };
}
